import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

// import '@/misc/register-service-worker'
// import '@/misc/handle-network-status'
// import '@/misc/handle-apple-install-prompt'
// import 'pwacompat'

import './assets/cookie-consent/jnv-consent.css'

import '@/misc/scroll-to'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

const consent = window.JNVConsent.init({
  version: 1,
  locale: 'fr',
  privacyUrl: false,

  services: {
    gtm: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID
      ? {
          type: 'gtm',
          id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID,
        }
      : null,

    ga4: process.env.VUE_APP_GA4_ID
      ? {
          type: 'ga4',
          id: process.env.VUE_APP_GA4_ID,
          // We send SPA pageviews ourselves.
          sendPageView: false,
        }
      : null,

    meta: process.env.VUE_APP_META_PIXEL_ID
      ? {
          type: 'meta',
          id: process.env.VUE_APP_META_PIXEL_ID,
        }
      : null,

    clarity: process.env.VUE_APP_CLARITY_ID
      ? {
          type: 'clarity',
          id: process.env.VUE_APP_CLARITY_ID,
        }
      : null,
  },
})

// Initial SPA page view after consent if analytics is already allowed.
if (consent.has('analytics')) {
  consent.trackPageView(router.currentRoute.fullPath)
}

router.afterEach((to) => {
  consent.trackPageView(to.fullPath)
})
